module.exports = __webpack_public_path__ + "static/media/pinme4.3981fe0b.gif";